import {Int, intersection, TypeOf} from 'io-ts';
import {Positive} from './Positive';

export const PositiveInt = intersection([Int, Positive]);

export type PositiveInt = TypeOf<typeof PositiveInt>;
